import { ApexDepositForm } from '../../../../investment/components/transfer/ApexDepositForm';

export default function DepositPage() {
    return <ApexDepositForm />;
}
